var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-autocomplete',{attrs:{"items":_vm.trainDeviationTypes,"rules":[_vm.required],"item-value":"key","item-text":"name","outlined":"","label":"Avvikelsetyp"},model:{value:(_vm.deviation_type),callback:function ($$v) {_vm.deviation_type=$$v},expression:"deviation_type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }